import { render, staticRenderFns } from "./FeedView.vue?vue&type=template&id=78052f61&"
import script from "./FeedView.vue?vue&type=script&lang=js&"
export * from "./FeedView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports